import React, { FC } from 'react';
import PropTypes from 'prop-types';

import { makeClassNames, IClassNames } from '../../../utils/styles';
import { Button } from '../../atoms';
import IconChevronLeft from '../../atoms/icons/icon-chevron-left';
import t from '../../../labels/labelling-utils';
import { isValidUrl } from '../../../utils/urls-utils';

import './back-button.scss';

export interface IBackButton {
  url: string;
  onClickCallback: (arg0: string) => void;
}

const classNames = (): IClassNames =>
  makeClassNames({
    backButtonContainer: 'back-button-container',
    backButton: 'back-button',
  });

/**
 * Renders a BackButton component passing an ARRAY of ROWS
 * @param url string - Url for back navigation
 * @param onClickCallback function - Function to run on elements click
 */
const BackButton: FC<IBackButton> = ({ url, onClickCallback }) => {
  const cn = classNames();

  const onButtonClick = () => {
    isValidUrl(url) && onClickCallback && onClickCallback(url);
  };

  return (
    <div className={cn.backButtonContainer} onClick={onButtonClick}>
      <Button dataAttributes={{ className: cn.backButton, 'aria-label': t('go.back') }}>
        <IconChevronLeft size="xsmall" color="dark" />
      </Button>
    </div>
  );
};

BackButton.propTypes = {
  onClickCallback: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
};

export default BackButton;
